import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recipient: {
    description: 'otherShippingOptions.billTo.recipient',
    defaultMessage: 'Recipient',
    id: 'Z6gsfJ',
  },
  thirdParty: {
    description: 'otherShippingOptions.billTo.thirdParty',
    defaultMessage: 'Third Party',
    id: 'MZxIAK',
  },
  default: {
    description: 'oterShippingOptions.billTo.empty',
    defaultMessage: 'Change Billing',
    id: 'DgPXAs',
  },
  primaryAccount: {
    description: 'otherShippingOptions.primaryAccount',
    defaultMessage: '{accountName} (Primary)',
    id: 'VdtXLa',
  },
  collect: {
    description: 'otherShippingOptions.collect',
    defaultMessage: 'FedEx Ground Collect',
    id: 'BH06q/',
  },
});
